import { FC } from 'react'
import { Routes, Route } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { RecyclingProvider } from './contexts/RecyclingContext'
import ProtectedRoute from './components/ProtectedRoute'
import LoadingSplash from './components/LoadingSplash'
import Home from './pages/Home'
import Login from './pages/Login'
import TransactionPage from './pages/TransactionPage'
import RegulatorsPortal from './pages/RegulatorsPortal.tsx'
import SuppliersPortal from './pages/SuppliersPortal.tsx'
import AuditorsPortal from './pages/AuditorsPortal.tsx'
import RetailersPortal from './pages/RetailersPortal.tsx'
import PublicPortal from './pages/PublicPortal.tsx'
import AdminPortal from './pages/AdminPortal.tsx'
import Layout from './components/Layout'
import RvmPlanningPage from './pages/RvmPlanningPage'

const AppRoutes: FC = () => {
  // Access user for passing into RecyclingProvider if needed later
  const { user } = useAuth()
  return (
    <RecyclingProvider currentUser={user}>
      <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/transaction" element={<TransactionPage />} />
          
          {/* Protected routes */}
          <Route 
            path="/regulators/*" 
            element={
              <ProtectedRoute allowedRoles={['gov']}>
                <RegulatorsPortal />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/suppliers/*" 
            element={
              <ProtectedRoute allowedRoles={['suppliers']}>
                <SuppliersPortal />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/auditors/*" 
            element={
              <ProtectedRoute allowedRoles={['auditors']}>
                <AuditorsPortal />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/retailers/*" 
            element={
              <ProtectedRoute allowedRoles={['retailers']}>
                <RetailersPortal />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/public/*" 
            element={
              <ProtectedRoute allowedRoles={['public']}>
                <PublicPortal />
              </ProtectedRoute>
            } 
          />
          <Route
            path="/admin/planning"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout portalType="admin">
                  <RvmPlanningPage homeRoute="/admin" title="RVM Planning Intelligence (Admin)" />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route 
            path="/admin/*" 
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminPortal />
              </ProtectedRoute>
            } 
          />
      </Routes>
    </RecyclingProvider>
  )
}

const App: FC = () => (
  <AuthProvider>
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50">
      <LoadingSplash />
      <AppRoutes />
    </div>
  </AuthProvider>
)

export default App